export const appLangToUrlLang = (language = 'uk') => {
  return language === 'uk' ? 'ua' : language;
};

export const urlLangToAppLang = (language = 'ua') => {
  return language === 'ua' ? 'uk' : language;
};

export const buildLevelPath = (language = 'uk', level = 'A1') => {
  return `/${appLangToUrlLang(language)}/${String(level || 'A1').toUpperCase()}`;
};

export const replaceUrlLanguageInPath = (pathname = '/', language = 'uk') => {
  const nextUrlLanguage = appLangToUrlLang(language);

  if (/^\/(ru|ua)(\/|$)/.test(pathname)) {
    return pathname.replace(/^\/(ru|ua)(?=\/|$)/, `/${nextUrlLanguage}`);
  }

  return pathname;
};
